import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const DialogPortalContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") DialogPortalContext.displayName = "DialogPortalContext";
function useDialogPortalContext() {
  const value = React.useContext(DialogPortalContext);
  if (value === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : formatErrorMessage(26));
  }
  return value;
}
export {
  DialogPortalContext,
  useDialogPortalContext
};
//# sourceMappingURL=DialogPortalContext.js.map
